import neuralnet from '../../assets/neuralnet.png';

import '../../styles/days.scss';

const Eight = () => (
  <div className='days full-image'>
    <img src={neuralnet} alt='neural net' />
  </div>
);

export default Eight;
